import {BsFillInfoCircleFill, BsCameraReelsFill} from "react-icons/bs";
import {AiFillCopyrightCircle} from "react-icons/ai";
// import {FaGamepad} from "react-icons/fa";
import {RiFullscreenFill, RiFullscreenExitFill} from "react-icons/ri";
import './IconBar.css'
import {useAppStore} from '../stores/store.js'
import {useGameStore} from '../stores/gameStore.js'
import {useCallback, useEffect, useRef, useState} from 'react'
import {INFO_PANEL_DATA} from '../utils/constants.jsx'

export function IconBar() {

    const resetCameraAction = useAppStore((state) => state.resetCamera)
    const startGame = useGameStore((state) => state.startGame)

    const infoRef = useRef(null)

    const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);

    const handleFullscreenChange = () => {
        setIsFullscreen(!!document.fullscreenElement);
    };

    useEffect(() => {
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari, Chrome, Opera
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);    // Firefox
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);   // IE/Edge

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            const elem = document.documentElement; // Request fullscreen for the whole page
            if (elem.requestFullscreen) {
                elem.requestFullscreen().catch(err => {
                    console.error(`FS Error: ${err.message} (${err.name})`);
                });
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                elem.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen().catch(err => {
                    console.error(`Exit FS Error: ${err.message} (${err.name})`);
                });
            } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { /* Chrome, Safari & Opera */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
            }
        }
    };

    const handleInfoClick = useCallback((event) => {
        event.stopPropagation()
        const {selectObject} = useAppStore.getState()

        selectObject(INFO_PANEL_DATA.info.id)
    }, [])

    const handleCreditsClick = useCallback((event) => {
        event.stopPropagation()
        const {selectObject} = useAppStore.getState()

        selectObject(INFO_PANEL_DATA.credits.id)
    }, [])

    const handleGameClick = useCallback((event) => {
        event.stopPropagation()
        startGame()
    }, [])

    return (<>
        <div className='icon-bar'>
            <div onClick={toggleFullscreen} className='icon-bar-item'
                 title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}>
                {isFullscreen ? <RiFullscreenExitFill/> : <RiFullscreenFill/>}
            </div>
            {/*<div onClick={handleGameClick} className='icon-bar-item' title="Help / Guide">
                <FaGamepad/>
            </div>*/}
            <div ref={infoRef} onClick={handleInfoClick} className='icon-bar-item' title="Help / Guide">
                <BsFillInfoCircleFill/>
            </div>
            <div className='icon-bar-item' title="Reset the view">
                <BsCameraReelsFill onClick={resetCameraAction}/>
            </div>
            <div className='icon-bar-item' title="Credits">
                <AiFillCopyrightCircle onClick={handleCreditsClick}/>
            </div>
        </div>
    </>)
}